import React, { memo } from 'react';
import productParameterConfigs from './config';
import ProductParameterEditor from './ProductParameterEditor';
function ProductCertificateEditor({ create = false }) {
    return React.createElement(ProductParameterEditor, { config: productParameterConfigs.certificates, create: create });
}
export default memo(ProductCertificateEditor);
